import { memo } from 'react';
import type { InputHTMLAttributes, Ref } from 'react';
import { _js } from '@ifixit/localize';

type SearchInputProps = {
   className?: string;
   containerProps?: Record<string, any>;
   ref?: Ref<HTMLInputElement>;
} & InputHTMLAttributes<HTMLInputElement>;

export const SearchInput = memo(function SearchInput({
   ref,
   className,
   containerProps,
   ...props
}: SearchInputProps) {
   const searchlabel = _js('Search');

   return (
      <div className={`my-4 ${className ? className : ''}`} {...containerProps}>
         <input
            className="border rounded-lg bg-white py-2 px-3 h-[48px] text-[16px] w-full"
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            type="search"
            aria-label={searchlabel}
            placeholder={searchlabel}
            ref={ref}
            {...props}
         />
      </div>
   );
});
